import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";


import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import AlertErrorForm from "../../component/AlertErrorForm";
import SearchBoxModal from "../../component/SearchBoxModal";
import { checkRole } from "../../model";

export default function FormTaiKhoan() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const allowSetRoles = checkRole(user, 'users', 'roles');
    
    const defaultdetail = {
        author_id: user.data.id,
        fullname: '',
        alias: '',
        code: '',
        type: 1,
        description: '',
        body_content: '',
        price: '',
        interest_rate: '',
        status: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "users/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            // console.log(res.data.data)
                            if (mounted) {
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, autoRefresh]
    );
    let validForm = {
        fullname: Yup.string().trim().nullable().required('Nhập họ tên').max(250, "Độ dài không quá 250 ký tự"),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];

            setLoading(true)
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'users/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật tài khoản thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'users', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới tài khoản thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="users">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/users">Danh sách tài khoản</Link>
                    </li>
                    <li>{id ? 'Sửa tài khoản' : 'Thêm mới tài khoản'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} tài khoản</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-sm-4 col-12 form-group">
                                <label>Tên tài khoản <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname")} disabled autoComplete="off" />
                                <AlertErrorForm formik={formik} name="fullname"></AlertErrorForm>
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Mã nhân viên <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("code")} disabled autoComplete="off" />
                                <AlertErrorForm formik={formik} name="code"></AlertErrorForm>
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Email <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("email")} disabled autoComplete="off" />
                                <AlertErrorForm formik={formik} name="email"></AlertErrorForm>
                            </div>

                            <div className="col-sm-4 col-12 form-group">
                                <label>Phòng ban <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"department"} alldata={"?limit=25"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} 
                                disabled={true}
                                defaultValue={formik.values['department_id']} name='department_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('department_id', e)
                                    }}></SearchBoxModal>

                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Quyền <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"roles"} alldata={"?limit=25"} placeholder="Chọn quyền" colvalue={'id'} colname={'title'} 
                                disabled={!allowSetRoles}
                                defaultValue={formik.values['role_id']} name='role_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('role_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="role_id"></AlertErrorForm>

                            </div>

                            <div className="col-sm-4 col-12 form-group">
                                <label>Loại tài khoản: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("type")}>
                                    <option value="1" >Quản trị</option>
                                    <option value="2" >Sale</option>
                                </select>
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Trạng thái: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("status")}>
                                    <option value="1" >Đang hoạt động</option>
                                    <option value="0" >Ngưng hoạt động</option>
                                </select>
                            </div>

                            <div className="col-12 mt-3" ></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{loading ? <div className="loader"></div> : <>Lưu tài khoản</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
